export function originalMsgSubTokens(script: string): string[] {
  const tokens: string[] = [];
  let rest = script;
  while (rest.length > 0) {
    const delimiter = rest.indexOf("\\");
    if (delimiter < 0) {
      tokens.push(rest);
      rest = "";
    } else {
      tokens.push(rest.slice(0, delimiter));
      rest = rest.slice(delimiter + 1);
    }
  }
  return tokens;
}

export function originalMsgSubFields(token: string): string[] {
  const fields: string[] = [];
  let rest = token;
  while (rest.length > 0) {
    const dot = rest.indexOf(".");
    const space = rest.indexOf(" ");
    let delimiter = -1;
    if (dot < 0 && space < 0) {
      fields.push(rest);
      rest = "";
    } else {
      delimiter = dot >= 0 && (space < 0 || dot < space) ? dot : space;
      fields.push(rest.slice(0, delimiter));
      rest = rest.slice(delimiter + 1);
    }
  }
  return fields;
}

export function originalMsgSubCommandName(token: string): string {
  return originalMsgSubFields(token)[0]?.toUpperCase() ?? "";
}

export function originalMsgSubArgs(token: string): string[] {
  return originalMsgSubFields(token).slice(1);
}

export function originalMsgSubIsColonLabelLine(token: string): boolean {
  return originalMsgSubFields(token)[0]?.startsWith(":") ?? false;
}

export function originalMsgSubJumpTarget(target = ""): string {
  return target.toUpperCase();
}

export function originalMsgSubJumpLine(tokens: readonly string[], target: string): number | undefined {
  const normalized = originalMsgSubJumpTarget(target);
  if (!normalized || normalized === "-") return undefined;
  for (let index = 0; index < tokens.length; index += 1) {
    if (tokens[index].slice(0, normalized.length).toUpperCase() === normalized) return index + 1;
  }
  return -1;
}
